module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 11-13-18-805.a1ff3278.mp4";